import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=6c20658c"
import script from "./ReportList.vue?vue&type=script&lang=ts"
export * from "./ReportList.vue?vue&type=script&lang=ts"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=6c20658c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports